(function ($, Drupal, drupalSettings) {

  Drupal.behaviors.init_header_search = {
    attach: function (context, settings) {
      
      var addSearchSiteKey = drupalSettings.law_addsearch.addSearchSiteKey;
      // AddSearch JS client with an example index. Get your own SITEKEY by signing up at www.addsearch.com
      var client = new AddSearchClient(addSearchSiteKey);

      var conf = {
        searchResultsPageUrl: '/search',
        updateBrowserHistory: false
      };

      // Search UI instance
      var searchui = new AddSearchUI(client, conf);

      // Add components
      searchui.searchField({
        containerId: 'search-text',
        placeholder: 'Search Hagens Berman...'
      });
      

      var autocompleteTemplate = '<div class="addsearch-autocomplete">'+
      '{{#gt suggestions.length 0}}'+
      ' <ul class="suggestions">'+
      '  {{#each ../suggestions}}'+
      '    <li data-keyword="{{value}}" data-index="{{@index}}" {{#equals ../../activeSuggestionIndex @index}}class="active"{{/equals}}>'+
      '    {{{value}}}'+
      '  </li>'+
      ' {{/each}}'+
      '</ul>'+
      '{{/gt}}'+
      ' {{#gt customFields.length 0}}'+
      '  <ul class="suggestions">'+
      '   {{#each ../customFields}}'+
      '    <li data-keyword="{{value}}" data-index="{{@index}}" {{#equals ../../activeSuggestionIndex @index}}class="active"{{/equals}}>'+
      '     {{value}}'+
      '   </li>'+
      ' {{/each}}'+
      '  </ul>'+
      ' {{/gt}}'+
      '</div>';

      // Don't forget to set up Search Suggestions on AddSearch Dashboard first
      searchui.autocomplete({
      containerId: 'headersearchautocomplete',
      sources: [
          {
          type: AddSearchUI.AUTOCOMPLETE_TYPE.SUGGESTIONS
          }
      ],
      template: autocompleteTemplate
      });
      
      // All components added. Start
      searchui.start();

    }

  }

})(jQuery, Drupal, drupalSettings);
